<template>
  <div class="hj-header">
    <div class="hj-header__item" @click="openMenu">
      <i class="fas fa-bars"></i>

      <strong v-if="showText && franchiseName" v-text="franchiseName"></strong>
    </div>

    <div class="hj-header__item" @click="goToFranchise">
      <transition>
        <strong v-if="showText">
          Mudar Empresa
        </strong>
      </transition>

      <i class="fas fa-exchange-alt"></i>
    </div>

    <v-dialog
      v-if="['Home'].includes($route.name)"
      ref="dialog"
      v-model="datePickerShow"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="hj-header__item">
          <transition>
            <strong v-if="showText" v-text="dateText"></strong>
          </transition>
          <i class="far fa-calendar-alt"></i>
        </div>
      </template>
      <v-date-picker v-model="datepickerValue" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="closeDatePicker">
          Cancelar
        </v-btn>
        <v-btn text color="primary" @click="changeDate">
          Alterar
        </v-btn>
      </v-date-picker>
    </v-dialog>

    <v-menu offset-y rounded>
      <template v-slot:activator="{ attrs, on }">
        <div class="hj-header__item" v-bind="attrs" v-on="on">
          <transition>
            <strong v-if="showText" v-text="userName"></strong>
          </transition>
          <i class="fas fa-user-tie"></i>
        </div>
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-title @click.prevent="logout()">Sair</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "hjHeader",
  data: () => ({
    datePickerShow: false,
    datepickerValue: "",
  }),
  computed: {
    ...mapGetters(["userName", "franchiseName"]),
    dateText() {
      return (
        this.$moment(this.datepickerValue).format("DD/MM/YYYY") ||
        this.$moment().format("DD/MM/YYYY")
      );
    },
    showText() {
      return this.$mq !== "mobile" && this.$mq !== "tablet";
    },
  },
  methods: {
    ...mapActions({
      clearFranchise: "_CLEAR_FRANCHISE",
      logout: "_LOGOUT",
      setFranchiseDate: "_SET_FRANCHISE_DATE",
    }),

    logout() {
      this.clearFranchise();
      this.logout();

      this.$router.push("/");
    },
    goToFranchise() {
      this.clearFranchise();
    },

    closeDatePicker() {
      this.datePickerShow = false;
    },

    changeDate() {
      this.closeDatePicker();

      this.setFranchiseDate(this.datepickerValue);
      this.$root.$emit("reload-all-franchise-graphs");
    },

    openMenu() {
      this.$emit("openMenu");
    },
  },
};
</script>

<style scoped lang="scss">
$blue: #303f9f;
$white: #fff;
.hj-header {
  width: 100vw;
  height: auto;
  min-height: 50px;

  padding: 12px 16px;
  background: $blue;

  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  color: $white;
  position: fixed;
  z-index: 9;
  top: 0;

  &__item {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    strong {
      font-size: 1rem;
    }
  }
}
</style>
